import moment from 'moment';
import { memo, useState, useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import ZeroStates from '../../ZeroStates';
import { useSelector } from 'react-redux';
import { BzLoader } from '../../../components';

const ExchangeNotificationMessages = ({ arrNse, notificationExchange, searchText }) => { //  Hari K :06-11-2023: BT-109371 message hub -receiving seach text prop

    const [currentDate, setCurrentDate] = useState(new Date());
    const [arrExchangeWiseData, setArrExchangeWiseData] = useState(); // Hari K :06-11-2023, BT-109371 message hub - maintained local state for search functionality
    const isNseAPIFailed = useSelector(state => state.messages.isNseAPIFailed); //  Hari K :06-11-2023: BT-109371 message hub -receving isNseAPIFailed redux state
    const IsNseAPIPendingStatus = useSelector(state => state.messages.IsNseAPIPendingStatus);

    const date = moment(currentDate)?.format("DD MMM' YY");

    // Hari K:06-11-2023, BT-109371 message hub - search functionality-start
    useEffect(() => {
        if (searchText?.length > 0) {
            const filteredArrExchangeWiseData = arrNse?.filter((each) => each?.msg?.toLowerCase()?.includes(searchText?.toLowerCase()));
            setArrExchangeWiseData(filteredArrExchangeWiseData);
        } else {
            setArrExchangeWiseData(arrNse);
        }
    }, [arrNse, searchText]);
    // Hari K:06-11-2023, BT-109371 message hub - search functionality-end
    
    return (
        <Container fluid className='p-0'>
            {arrNse?.length > 0 ?
                <>
                    {arrExchangeWiseData?.length > 0 ? arrExchangeWiseData?.map((each, i) => (
                        <Row className='g-0 justify-content-evenly mb-2 py-2 px-2 bdr-btm'>
                            <Col md='auto'>
                                <div className={`icon-36 icon-exchange-${notificationExchange?.split('_')[0]?.toLowerCase()} me-2`}></div>
                            </Col>
                            <Col md={10} key={i}>
                                <div className='font-medium font-size1 color-text'>{each?.msg}</div>
                                <div className='font-regular font-size1 color-subtext mt-1'>{date} {moment(each?.time, 'HH:mm:ss')?.format('h:mm A')}</div>
                            </Col>
                        </Row>
                    )) : searchText?.length ?
                        // Ameersha N :15-11-2023 SAT-109371 message hub - issue - No data found after search - Start
                        <div className='zero-state-alerts zero-state-alerts-xl'>
                            <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                            <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                            <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                        </div>
                        // Ameersha N :15-11-2023 SAT-109371 message hub - issue - No data found after search - End
                        : null}

                </> :
                (IsNseAPIPendingStatus && arrNse?.length <= 0) ?
                    <div className='zero-state-alerts zero-state-alerts-xl'>
                        <BzLoader spinner={IsNseAPIPendingStatus} spinnerContent={"Fetching Details"} />
                    </div>
                    : (arrNse?.length <= 0 && isNseAPIFailed) ? // Hari K:02-11-2023 zero state changes
                        <div className='zero-state-alerts zero-state-alerts-xl'>
                            {/* // Ameersha N :15-11-2023 SAT-109371 message hub - issue - changed subText to  "Currently there are no notifications" */}
                            <ZeroStates subText="Currently there are no notifications" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                        </div> : null
            }
        </Container>

    );
};

export default memo(ExchangeNotificationMessages);